export const INVALID_UPLOAD_FILENAME_PATTERN = /[ ,]/;

export const getInvalidUploadFilenameMessage = () =>
    "File name cannot contain spaces or commas. Please rename the file and try again.";

export const isUploadFilenameValid = (fileName = "") =>
    !INVALID_UPLOAD_FILENAME_PATTERN.test(String(fileName));
